/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetCompanyListParams,
  GetCompanyListResponseDto,
  GetCompanyUsersResponseDto,
  GetUsersWithAnyOfPermissionsParams,
  UpdateCompanyDefaultOwnerRequest,
  UpdateCompanyDefaultOwnerResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get companies information
 */
export const getCompanyList = (
    params?: GetCompanyListParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetCompanyListResponseDto>(
      {url: `/companies`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCompanyListQueryKey = (params?: GetCompanyListParams,) => {
    return [`/companies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyListQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(params?: GetCompanyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyList>>> = ({ signal }) => getCompanyList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyListQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyList>>>
export type GetCompanyListQueryError = unknown


export function useGetCompanyList<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params: undefined |  GetCompanyListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyList>>,
          TError,
          Awaited<ReturnType<typeof getCompanyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyList<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params?: GetCompanyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyList>>,
          TError,
          Awaited<ReturnType<typeof getCompanyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyList<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params?: GetCompanyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get companies information
 */

export function useGetCompanyList<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params?: GetCompanyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(params?: GetCompanyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyList>>> = ({ signal }) => getCompanyList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanyListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyList>>>
export type GetCompanyListSuspenseQueryError = unknown


export function useGetCompanyListSuspense<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params: undefined |  GetCompanyListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyListSuspense<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params?: GetCompanyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanyListSuspense<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params?: GetCompanyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get companies information
 */

export function useGetCompanyListSuspense<TData = Awaited<ReturnType<typeof getCompanyList>>, TError = unknown>(
 params?: GetCompanyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get company users with any of the specified permissions
 */
export const getUsersWithAnyOfPermissions = (
    companyId: string,
    params?: GetUsersWithAnyOfPermissionsParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetCompanyUsersResponseDto>(
      {url: `/companies/${companyId}/users`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUsersWithAnyOfPermissionsQueryKey = (companyId?: string,
    params?: GetUsersWithAnyOfPermissionsParams,) => {
    return [`/companies/${companyId}/users`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUsersWithAnyOfPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError = null>(companyId: string,
    params?: GetUsersWithAnyOfPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersWithAnyOfPermissionsQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>> = ({ signal }) => getUsersWithAnyOfPermissions(companyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersWithAnyOfPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>>
export type GetUsersWithAnyOfPermissionsQueryError = null


export function useGetUsersWithAnyOfPermissions<TData = Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError = null>(
 companyId: string,
    params: undefined |  GetUsersWithAnyOfPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>,
          TError,
          Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersWithAnyOfPermissions<TData = Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError = null>(
 companyId: string,
    params?: GetUsersWithAnyOfPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>,
          TError,
          Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersWithAnyOfPermissions<TData = Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError = null>(
 companyId: string,
    params?: GetUsersWithAnyOfPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get company users with any of the specified permissions
 */

export function useGetUsersWithAnyOfPermissions<TData = Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError = null>(
 companyId: string,
    params?: GetUsersWithAnyOfPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithAnyOfPermissions>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersWithAnyOfPermissionsQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Set or update the default owner for a company
 */
export const CompaniesController_updateDefaultOwner = (
    companyId: string,
    updateCompanyDefaultOwnerRequest: UpdateCompanyDefaultOwnerRequest,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateCompanyDefaultOwnerResponseDto>(
      {url: `/companies/${companyId}/defaultOwner`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyDefaultOwnerRequest
    },
      options);
    }
  


export const getCompaniesControllerUpdateDefaultOwnerMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof CompaniesController_updateDefaultOwner>>, TError,{companyId: string;data: UpdateCompanyDefaultOwnerRequest}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof CompaniesController_updateDefaultOwner>>, TError,{companyId: string;data: UpdateCompanyDefaultOwnerRequest}, TContext> => {

const mutationKey = ['companiesControllerUpdateDefaultOwner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof CompaniesController_updateDefaultOwner>>, {companyId: string;data: UpdateCompanyDefaultOwnerRequest}> = (props) => {
          const {companyId,data} = props ?? {};

          return  CompaniesController_updateDefaultOwner(companyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesControllerUpdateDefaultOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof CompaniesController_updateDefaultOwner>>>
    export type CompaniesControllerUpdateDefaultOwnerMutationBody = UpdateCompanyDefaultOwnerRequest
    export type CompaniesControllerUpdateDefaultOwnerMutationError = null | null

    /**
 * @summary Set or update the default owner for a company
 */
export const useCompaniesControllerUpdateDefaultOwner = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof CompaniesController_updateDefaultOwner>>, TError,{companyId: string;data: UpdateCompanyDefaultOwnerRequest}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof CompaniesController_updateDefaultOwner>>,
        TError,
        {companyId: string;data: UpdateCompanyDefaultOwnerRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesControllerUpdateDefaultOwnerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    